<template>
  <b-form-select class="location-distance-dropdown" plain :value="value || distances[0]" @input="v => $emit('input', v)" :options="distances"/>
</template>

<script>
import assert from 'http-assert-plus';

export default {
  props: {
    distances: {
      type: Array,
      default: () => [ '10mi', '25mi', '50mi', '100mi', '150mi', '200mi', '300mi', '400mi', '500mi' ],
      validate(a) {
        assert(Array.isArray(a) && a.length > 0, new Error('Expected an array with values'));
        a.forEach(v => assert(typeof v === 'string' && v.length, new Error('Expected each value to be a string')));
      },
    },
    value: {
      type: String,
      default: () => null,
    },
  },
  mounted() {
    this.$emit('input', this.value || this.distances[0]);
  },
};
</script>

<style lang="scss">
.location-distance-dropdown {
  display: inline-block;
  font-size: 12px;
  height: 19px;
  width: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/LocationDistanceDropdown.vue